module.exports = __webpack_public_path__ + "img/logoSirius.698d10fd.png";